import { ref } from "vue";
import {} from "@/components/Datatypes/model";
import { useDatatypesMapperStore } from "@/stores/datatypesMapperStore";
export function useDatatypesMapper() {
    const datatypesMapperLoading = ref(true);
    const datatypesMapper = ref(null);
    const datatypesMapperStore = useDatatypesMapperStore();
    const datatypes = ref([]);
    async function getDatatypesMapper() {
        await datatypesMapperStore.createMapper();
        datatypesMapperLoading.value = datatypesMapperStore.loading;
        datatypesMapper.value = datatypesMapperStore.datatypesMapper;
        if (datatypesMapperStore.datatypesMapper) {
            datatypes.value = datatypesMapperStore.datatypesMapper.datatypes;
        }
    }
    getDatatypesMapper();
    return { datatypes, datatypesMapper, datatypesMapperLoading };
}
